<template>
    <div>
        <CauseItem
            v-if="postType === 'cause'"
            :cause="cause"
            :index="index"
            :click-handler="clickHandler"
            :is-select="isSelect"
            :is-Single="isSingle"
        ></CauseItem>
        <PartnerItem
            v-else
            :cause="cause"
            :click-handler="clickHandler"
            :is-single="isSingle"
        ></PartnerItem>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import mixins from "../../config/mixins";
import CauseItem from "../Cause/CauseItem";
import PartnerItem from "../Partners/PartnerItem";

export default {
    name: "PostItem",

    mixins: [mixins.npos],

    components: {
        PartnerItem,
        CauseItem,
        Swiper,
        SwiperSlide,
    },

    directives: {
        swiper: directive,
    },

    props: [
        "cause",
        "index",
        "clickHandler",
        "isSelect",
        "postType",
        "isSingle",
    ],

    data: function() {
        return {
            locale: this.$i18n.locale,
            options: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
        };
    },

    computed: {
        truncateContent: function() {
            let content = this.getNposContent("desc");
            if (content) {
                return content.substr(0, 110) + "...";
            }
            return "";
        },
    },

    methods: {
        saveChoice: function() {
            this.$http
                .post("user/addnpo", { npo_id: this.cause.id })
                .then(data => {
                    if (data && data.status !== undefined && data.status) {
                        this.saveNposChoice(this.getNposContent("title"));
                        if (this.$route.path === "/login") {
                            this.$store.commit("userUpdate", {pr_npo: true});
                            this.$store.commit("loginActiveStep", "bank");
                            this.$store.commit("loginSteps", { cause: true });
                        }
                    }
                });
        },
    },
};
</script>
